
export default {
	created() {

		// This works, for some reason...
		window.onbeforeunload = function() {};

		const pageShowListener = window.addEventListener('pageshow', (event) => {
			if (event.persisted && this.handlePagePersisted) {
				this.handlePagePersisted();
			}
		});

		this.$once('hook:beforeDestroy', () => {
			window.removeEventListener('pageshow', pageShowListener);
		});
	}
};
